import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import GetDistricts from "../Dropdowns/getDistricts";
import GetAfsoo from "../Dropdowns/getAfsoo";

const FPS_Active_Int = () => {
  const [month, setMonth] = useState(0);
  const [monthName, setMonthName] = useState('');
  const [year, setYear] = useState('');
  const [district, setDistrict] = useState('');
  const [distCode, setDistCode] = useState('');
  const [afsoCode, setAfsoCode] = useState('');
  const [afsoName, setAfsoName] = useState('');
  const [fpsStatus, setFpsStatus] = useState('');
  const [submittedStatus, setSubmittedStatus] = useState('');
  const [statuses, setStatuses] = useState([]);
  const [fpsList, setFpsList] = useState([]);
  const [selectedFpsIds, setSelectedFpsIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [noDataMessage, setNoDataMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [loadingAfso, setLoadingAfso] = useState(false);

  const districtSelectRef = useRef(null);

  const getMonthName = (monthNumber) => {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    return months[monthNumber - 1] || '';
  };

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_URL}/api/fps/currentmonthyear`, {
      withCredentials: true
    }).then(res => {
      const monthNumber = res.data.month;
      setMonth(monthNumber);
      setMonthName(getMonthName(monthNumber));
      setYear(res.data.year);
    }).catch(err => {
      console.error("Error fetching current data:", err);
    });

    axios.get(`${process.env.REACT_APP_URL}/api/fps/fpsstatus`).then(res => {
      setStatuses(res.data.map(row => row.status));
    });
  }, []);

  const handleDistrictChange = (code) => {
    console.log("District changed - Code:", code);
    setDistCode(code);

    if (districtSelectRef.current) {
      const selectElement = districtSelectRef.current.querySelector('select');
      if (selectElement) {
        const selectedOption = selectElement.options[selectElement.selectedIndex];
        const districtName = selectedOption ? selectedOption.text : '';
        console.log("District Name:", districtName);
        setDistrict(districtName);
      }
    }

    setAfsoCode('');
    setAfsoName('');
  };

  const handleAfsoChange = (code) => {
    console.log("AFSO changed - Code:", code);
    setAfsoCode(code);

    setTimeout(() => {
      const afsoSelect = document.getElementById('afso_code');
      if (afsoSelect) {
        const selectedOption = afsoSelect.options[afsoSelect.selectedIndex];
        const afsoName = selectedOption ? selectedOption.text : '';
        console.log("AFSO Name:", afsoName);
        setAfsoName(afsoName);
      }
    }, 100);
  };

  const handleSubmit = () => {
    if (!distCode) {
      alert("Please Select District");
      return;
    }
    if (!afsoCode) {
      alert("Please Select AFSO");
      return;
    }
    if (!fpsStatus) {
      alert("Please Select FPS Status");
      return;
    }

    setLoading(true);
    axios.get(`${process.env.REACT_APP_URL}/api/fps/details`, {
      params: {
        month,
        year,
        distCode: distCode || '0',
        afsoCode: afsoCode || '0',
        fpsStatus: fpsStatus || '0',
        deviceStatus: '0'
      }
    }).then(res => {
      setFpsList(res.data);
      setSelectedFpsIds([]);
      setSelectAll(false);
      setSubmittedStatus(fpsStatus);

      if (res.data.length === 0) {
        setNoDataMessage(`No data found`);
      } else {
        setNoDataMessage('');
      }
      setLoading(false);
    }).catch(err => {
      console.error("Error fetching FPS details:", err);
      setNoDataMessage("An error occurred while fetching data.");
      setLoading(false);
    });
  };

  const toggleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    if (newSelectAll) {
      setSelectedFpsIds(fpsList.map(fps => fps.fps_id));
    } else {
      setSelectedFpsIds([]);
    }
  };

  const toggleSingleCheckbox = (fpsId) => {
    if (selectedFpsIds.includes(fpsId)) {
      const newSelected = selectedFpsIds.filter(id => id !== fpsId);
      setSelectedFpsIds(newSelected);
      setSelectAll(false);
    } else {
      const newSelected = [...selectedFpsIds, fpsId];
      setSelectedFpsIds(newSelected);
      if (newSelected.length === fpsList.length) {
        setSelectAll(true);
      }
    }
  };

  const handleConvertStatus = async () => {
    const lowerStatus = submittedStatus?.toLowerCase();
    const targetStatus = lowerStatus === 'online' ? 'Poffline' : 'Online';
    const endpoint = lowerStatus === 'online'
      ? 'poffline'
      : lowerStatus === 'poffline'
        ? 'online'
        : `update?newStatus=${targetStatus}`;

    const selectedFpsData = fpsList
      .filter(fps => selectedFpsIds.includes(fps.fps_id))
      .map(fps => ({
        fps_id: fps.fps_id,
        old_status: fps.fps_status
      }));

    if (selectedFpsData.length === 0) {
      alert("Please select at least one FPS to convert.");
      return;
    }

    const payload = {
      fpsIds: selectedFpsData.map(f => f.fps_id),
      oldStatuses: selectedFpsData.map(f => f.old_status),
      month: month,
      year: year
    };

    try {
      const res = await axios.post(`${process.env.REACT_APP_URL}/api/fps/status/${endpoint}`, payload);
      alert(res.data || "Status updated successfully");
      handleSubmit();
    } catch (err) {
      console.error(err);
      alert("Failed to update FPS status.");
    }
  };

  const renderConvertButton = () => {
    const lowerStatus = (submittedStatus || '').toLowerCase();
    if (!(lowerStatus === 'online' || lowerStatus === 'poffline')) return null;

    const isOnline = lowerStatus === 'online';
    const buttonText = isOnline ? 'Convert to Partial Offline' : 'Convert to Online';
    const buttonColor = isOnline ? 'red' : 'green';

    return (
      <div style={{ margin: '10px 0' }}>
        <button
          onClick={handleConvertStatus}
          className="button button2"
          style={{
            backgroundColor: buttonColor,
            color: 'white',
            padding: '6px 12px',
            borderRadius: '15px',
            fontWeight: 'bold',
            border: 'none'
          }}
        >
          {buttonText}
        </button>
      </div>
    );
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        paddingBottom: '100px'
      }}
    >
      <table width="75%" border="1" cellPadding="10" style={{ marginTop: '30px' }}>
        <thead>
          <tr className="tableheader">
            <th colSpan="10">FPS Active/Inactive Details</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><b>Month</b></td>
            <td>{monthName}</td>
            <td><b>Year</b></td>
            <td>{year}</td>
            <td><b>District</b></td>
            <td>
              <div ref={districtSelectRef}>
                <GetDistricts
                  onLoadingChange={setLoadingDistricts}
                  onChange={handleDistrictChange}
                  selectedDistCode={distCode}
                />
              </div>
            </td>
            <td><b>AFSO</b></td>
            <td>
              {distCode ? (
                <GetAfsoo
                  dist_code={distCode}
                  onLoadingChange={setLoadingAfso}
                  onChange={handleAfsoChange}
                  selectedAfsoCode={afsoCode}
                />
              ) : (
                <select disabled>
                  <option value="">Select</option>
                </select>
              )}
            </td>
            <td><b>FPS Status</b></td>
            <td>
              <select value={fpsStatus} onChange={(e) => setFpsStatus(e.target.value.trim())}>
                <option value="">--Select--</option>
                {statuses.map((s, idx) => (
                  <option key={idx} value={s}>{s}</option>
                ))}
              </select>
            </td>
          </tr>
          <tr>
            <td colSpan="10" align="center">
              <button className="button button2" onClick={handleSubmit} style={{ marginRight: '10px' }}>Submit</button>
              <button className="button button2" onClick={() => window.history.back()}>Back</button>
            </td>
          </tr>
        </tbody>
      </table>

      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '15px' }}>
          <CircularProgress size={30} />
        </div>
      )}

      {!loading && noDataMessage && (

        <div
          align="center"
          style={{
            margin: '20px',
            fontWeight: 'bold',
            color: 'brown',
            textDecoration: 'underline',
            fontSize: '18px'
          }}
        >
          {noDataMessage}
        </div>
      )}

      {fpsList.length > 0 && !loading && (
        <>
          <div style={{ marginTop: '25px', marginBottom: '4px', fontWeight: 'bold', color: 'maroon' }}>
            Total FPS: {fpsList.length}
          </div>

          <div style={{ marginBottom: '4px' }}>
            {renderConvertButton()}
          </div>

          <table border="1" width="75%" cellPadding="8">
            <thead>
              <tr className="tableheader">
                <th colSpan="8">
                  {submittedStatus} FPS Details for {district} / {afsoName} / {monthName} {year}
                </th>
              </tr>
              <tr className="tableheader">
                <th>Sl.NO</th>
                <th>Office</th>
                <th>FPS Id</th>
                <th>Total<br />Cards</th>
                <th>Total<br />Units</th>
                <th>Device<br />Status</th>
                <th>FPS<br />Status</th>
                <th>
                  Status<br />
                  <button
                    onClick={toggleSelectAll}
                    style={{
                      backgroundColor: 'white',
                      color: 'black',
                      border: '1px solid gray',
                      padding: '2px 6px',
                      borderRadius: '4px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      marginTop: '4px'
                    }}
                  >
                    Select All
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              {fpsList.map((fps, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{fps.office_name_en}</td>
                  <td>{fps.fps_id}</td>
                  <td style={{ textAlign: 'right' }}>{fps.total_cards}</td>
                  <td style={{ textAlign: 'right' }}>{fps.total_units}</td>
                  <td style={{ color: fps.device_status === 'Mapped' ? 'green' : 'red' }}>
                    {fps.device_status}
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    {fps.fps_status === 'Active' ? 'Online' : fps.fps_status}
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedFpsIds.includes(fps.fps_id)}
                      onChange={() => toggleSingleCheckbox(fps.fps_id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div style={{ marginTop: '20px', marginBottom: '80px' }}>
            {renderConvertButton()}
          </div>
        </>
      )}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        style={{
          position: 'fixed',
          right: '18px',
          bottom: '18px',
          zIndex: 9999,
          backgroundColor: '#f1872bff',
          color: '#100d0dff',
          border: 'none',
          padding: '12px 14px',
          borderRadius: '20px',
          boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
          cursor: 'pointer'
        }}
        title="Go to Top"
      >
        Top
      </button>
    </div>
  );
};

export default FPS_Active_Int;